import React from "react";
import { useState } from "react";
import { convertArrayToCSV } from "convert-array-to-csv";
import FileSaver from "file-saver";
import "../Dashboard/Dashboard.css";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useDispatch } from "react-redux/es/exports";
import { useSelector } from "react-redux/es/exports";
import { AskpageNumber } from "../Model/AskpageNumber";
import Pagination from "../../utils/Pagination";
import axiosinstances from "../../Helper/useAxios";
import { isSuperAdmin, isUserAdmin } from "../../utils/comman/Common";
import { useNavigate, useParams } from "react-router-dom";
import { transactionType } from "../../utils/Constant";

const AccountHistory = () => {
  const selectedId = useSelector((state) => state.selectedRetailerReducer.id);
  const [axiosInstance] = axiosinstances();
  const navigate = useNavigate();
  const params = useParams();
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [showModal, setShowModel] = useState(false);
  const [selectedPage, setSelectedPage] = useState(1);
  const [search, setsearch] = useState("");
  const [exporttoDate, setExporttoDate] = useState("");
  const [exportFromdate, setexportFromdate] = useState("");
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 100,
    totalPost: 0,
    totalPages: 0,
  });
  const [table, settable] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [firstSelectedPage, setFirstSelectedPage] = useState();
  const [secondSelectedPage, setSecondSelectedPage] = useState();
  const [selectedCreditType, setSelectedCreditType] = useState('')
  const [selectOption, setSelectOption] = useState('')
  const [customPage, setCustomPage] = useState('')
  const [pageStart, setpageStart] = useState(0)
  const [pagelimit, setPagelimit] = useState(0)
  // useEffect(() => {
  //   if (fromDate !== "" || toDate !== "" ) fetchAllAccountHistory(0);
  // }, [toDate, fromDate, selectedCreditType]);
  const getAccHistory = () =>{
    if (fromDate !== "" || toDate !== "" ) fetchAllAccountHistory(0);
  }
//console.log('table', table)
const checkDisable = () =>{
  let disabled = true
  if( id !== undefined && fromDate !== '' && toDate !== '' && selectedId !== undefined && selectedId !== null && ( isSuperAdmin(id) || isUserAdmin(id))){
    disabled = false
  } else if( !isSuperAdmin(id) && !isUserAdmin(id) && fromDate !== '' && toDate !== ''){
    disabled = false
  }
  return disabled
}

  const fetchAllAccountHistory = async (pageNo) => {
    const ids = isUserAdmin(id) ? selectedId : params.id;
    let url = `/api/v1/account/history?entity=${ids}&page=${pageNo}`;
    if (fromDate !== "") {
      url = url + `&from=${fromDate}`;
    }
    if (toDate !== "") {
      url = url + `&to=${toDate}`;
    }

    if (selectedCreditType !== "") {
      url = url + `&type=${selectedCreditType}`;
    }

    //console.log("url", url);
    const response = await axiosInstance
      .get(url, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        //console.log("res....>", res);
        //  return res
        if (res.status === 200) {
          settable(res.data.history);
          setPaginationDetails((prev) => {
            return {
              ...prev,
              totalPost: res.data?.totalElements,
              totalPages: res.data?.totalPages,
            };
          });
          if(res.data.history !== null){
            setFromDate(res.data.fromDate);
            setToDate(res.data.toDate);
          }
        } 
       
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };
  useEffect(()=>{
    if(selectOption === "All" && firstSelectedPage !== undefined){
      setpageStart(1)
      setPagelimit(firstSelectedPage)
    } else if(selectOption == "Custom" && firstSelectedPage !== undefined && secondSelectedPage !== undefined ){
      setpageStart(firstSelectedPage)
      setPagelimit(secondSelectedPage)
    }
  
  },[selectOption, firstSelectedPage , secondSelectedPage])
  console.log('selectedId', selectedId)
  useEffect(() => {
    if(id !== undefined && selectedId !== undefined && selectedId !== null && (isSuperAdmin(id) || isUserAdmin(id))){
      fetchAllAccountHistory(0)
    } else if(id !== undefined  && !(isSuperAdmin(id) || isUserAdmin(id))){
     fetchAllAccountHistory(0);
    } else{
      settable([])
    }
  }, [id, selectedId]);
  //console.log("sss", table);
  const handalpageclick = async (index) => {
    setPaginationDetails((prev) => {
      return { ...prev, currentPage: index };
    });
    fetchAllAccountHistory(index - 1);
  };
  const totalpage = paginationDetails.totalPages;

  const d =
    sessionStorage.getItem("token") &&
    JSON.parse(sessionStorage.getItem("token")).token
      ? JSON.parse(sessionStorage.getItem("token")).token
      : "";
  const e = JSON.parse(sessionStorage.getItem("token"));

  const searchdata = async () => {
    setsearch((search) => {
      return search;
    });
    const callingsearchapi = await searchapidata(search);

    setsearch("");

    //settable(() => callingsearchapi.orders);
  };

  const searchapidata = async (search) => {
    const trimSearch = search.trim()
    const response = await axiosInstance
      .get(`/api/v1/billpay/order/search/${trimSearch}`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  const fetchpagedataInloop = async (pageNo) => {
    const ids = isUserAdmin(id) ? selectedId : params.id;
    let url = `/api/v1/account/history?entity=${ids}&page=${pageNo}`;
    if (exportFromdate !== "") {
      url = url + `&from=${exportFromdate}`;
    }
    if (exporttoDate !== "") {
      url = url + `&to=${exporttoDate}`;
    }
    if (selectedCreditType !== "") {
      url = url + `&type=${selectedCreditType}`;
    }
   
    const response = await axiosInstance
      .get(url, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        //console.log("res....>", res);
        return res;
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  const enterTxnsearch = (event) => {
    event.preventDefault();

    setsearch(event.target.value);
  };

 
  const nextclick = () => {
    setsearch(search + 1);
    setsearch((search) => {
      return search;
    });
  };

  const onExportData = () => {
    setShowModel(true);
  };
  const pageHandler = (page) => {
    //console.log("page", page);
  };
  const closePopUp = () => {
    setShowModel(false);
    setSelectedPage(1);
  };

  async function exportAllFile() {
    let result = [];
    for (let i = pageStart - 1; i < pagelimit; i++) {
      const data = await fetchpagedataInloop(i);
      if (Array.isArray(data?.history)) {
        const unwantedHeaderForExcel = data.history.map((val) => {
          val.account_id = val.id;
          delete val.postTxnAccSnapshot;
          delete val.id;
          delete val.refId;
          delete val.reversalRef;
          delete val.service;
          delete val.subType;
          delete val.updatedOn;
          return val;
        });
        result.push(...unwantedHeaderForExcel);
      }
    }
    //console.log("result", result);
    const csv = convertArrayToCSV(result);
    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, "data.csv");
    closePopUp();
    setSelectedPage(1);
  }

  const clearSearch = () => {
    setsearch("");
    // dispatch({ type: TRANSACTION_HISTORY, id })
  };
  const profileDetails = (id) => {
    navigate(`/profile/${id}`);
  };
  const fromDateHandler = (e) => {
    setFromDate(e.target.value);
    setexportFromdate(e.target.value);
  };
  const toDateHandler = (e) => {
    setToDate(e.target.value);
    setExporttoDate(e.target.value);
  };
console.log( 'table', table)
  const exportfromDateHandler = (e) => {
    setexportFromdate(e.target.value);
  };
  const exporttoDateHandler = (e) => {
    setExporttoDate(e.target.value);
  };
 
  //console.log("fro", exportFromdate, exporttoDate);
  return (
    <React.Fragment>
      <AskpageNumber
      showModal={showModal}
      closePopUp = {closePopUp}
      totalpage={totalpage} 
      setFirstSelectedPage={setFirstSelectedPage} 
      firstSelectedPage ={firstSelectedPage}
      exportAllFile={exportAllFile}
      secondSelectedPage={secondSelectedPage}
      setSecondSelectedPage={setSecondSelectedPage}
      selectOption={selectOption}
      setSelectOption={setSelectOption}
      customPage={customPage}
      setCustomPage={setCustomPage}
      />
      <div class="mid">
        <div class="container-fluid">
          <div class="maincard">
            <div class="tab-content" id="mobiletab">
              <div
                class="tab-pane fade show active"
                id="nav-mobi"
                role="tabpanel"
                aria-labelledby="mobile-tab"
              >
                <div class="head">
                  <h3>Account History</h3>
                  {/* <div class="headsearch">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        onChange={(event) => enterTxnsearch(event)}
                        placeholder="Search transaction..."
                        value={search}
                      />
                      <button
                        class="btn search"
                        disabled={search.length <= 3}
                        type="button"
                        id="txnsrch"
                        onClick={searchdata}
                      >
                        search
                      </button>
                      <button
                      style={{background:'#FF8D33', marginLeft:'3px'}}
                        class="btn delete"
                       // disabled={search.length <= 3}
                        type="button"
                        
                        onClick={clearSearch}
                      >
                        clear
                      </button>
                    </div>
                    
                  </div> */}
                </div>
                <div className="date-search">
                  <div
                    style={{ margin: 10 }}
                    class="form-floating float-left "
                  >
                    <input
                      type="date"
                      class="form-control"
                      id="from"
                      placeholder="From Date"
                      onChange={fromDateHandler}
                      value={fromDate}
                    />
                    <label style={{ padding: "1rem 1.75rem" }} for="from">
                      From
                    </label>
                  </div>
                  <div
                    style={{ margin: 10 }}
                    class="form-floating float-left"
                  >
                    <input
                      type="date"
                      class="form-control"
                      id="to"
                      min={fromDate}
                      placeholder="To Date"
                      onChange={toDateHandler}
                      value={toDate}
                      disabled={fromDate == ""}
                    />
                    <label style={{ padding: "1rem 1.75rem" }} for="to">
                      To
                    </label>
                  </div>
                  <div  style={{ margin: 10 }} className="date-search ms-2"  >
                  <div class="form-floating float-left">
                    <select class="form-select" id="type" name="type" value={selectedCreditType} onChange={(e)=>setSelectedCreditType(e.target.value)} >
                      <option value="">Select</option>
                      <option value="CREDIT">CREDIT</option>
                      <option value="DEBIT">DEBIT</option>
                      <option value="MANUAL_CREDIT">MANUAL CREDIT</option>

                      <option value="AUTO_REVERSAL">AUTO REVERSAL</option>
                      <option value="MANUAL_REVERSAL">MANUAL REVERSAL</option>
                      <option value="ADD_CREDIT_LIMIT">ADD CREDIT LIMIT</option>

                      <option value="REDUCE_CREDIT_LIMIT">REDUCE CREDIT LIMIT</option>
                      <option value="ADD_LIEN">ADD LIEN</option>
                      <option value="REDUCE_LIEN">REDUCE LIEN</option>
                    </select>
                    <label for="type">Select Trxn Type</label>
                  </div>
                </div>
                </div>
           <div className="float-right"   style={{ margin: 10 }}>
           <button
          type="button"
          className={checkDisable() ? "btn btn-secondary":"btn btn-primary" } 
           onClick={getAccHistory}
           disabled={checkDisable()}
        >
          Search
        </button>
            </div>     
          
                <div class="txn-list" id="recntxn">
                  {table !== undefined &&
                    table !== null && Array.isArray(table) && table.length > 0 ?
                    table?.map((data) => {
                      return (
                        <div class="txn-item" key={data.id}>
                          <div class="txn-head" id="txnhead1">
                            <div
                              class="collapsed"
                              data-bs-toggle="collapse"
                              data-bs-target="#txn1"
                              aria-expanded="false"
                              aria-controls="txn1"
                            >
                              <div
                                class={`txncard ${
                                  data.type === "DEBIT"
                                    ? "failed rdbg"
                                    : `${
                                        data.type === "MANUAL_DEBIT" ||
                                        data.type === "ADD_LIEN" ||
                                        data.type === "REDUCE_LIEN"
                                          ? "failed rdbg"
                                          : "success grbg"
                                      }`
                                }`}
                                // className="txncard success grbg"
                              >
                                <div class="row">
                                  <div class="col-12 col-md-3">
                                    <div class="txntxt">
                                      <h6>
                                        Id: {data?.type !== null && data?.id}
                                      </h6>
                                    </div>
                                    <div class="txntxt">
                                      <h6>
                                        Type:{" "}
                                        {data.type !== null &&
                                          transactionType[data?.type] !==
                                            undefined &&
                                          transactionType[data?.type]}
                                      </h6>
                                    </div>
                                  </div>
                                  {/* <div class="col-12 col-sm-5 col-lg-3">
                                  <div class="txntxt">
                                    <h6>Txn ID: {data.requestId}</h6>
                                  </div>
                                </div> */}

                                  <div class="col-12 col-md-2">
                                    <div class="txntxt">
                                      <h6>
                                        {" "}
                                        Subtype :{" "}
                                        {data?.subType !== null &&
                                          data.subType}{" "}
                                      </h6>
                                      <h6>
                                        {" "}
                                        service :{" "}
                                        {data?.service !== null &&
                                          data.service}{" "}
                                      </h6>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-2">
                                    <div class="txntxt">
                                      {/* <h4>
                                      ₹ {200}{" "}</h4> */}
                                      <h6>
                                        {" "}
                                        Bal Before :{" "}
                                        {data?.balanceBefore !== null &&
                                          data.balanceBefore}{" "}
                                      </h6>
                                      <h6>
                                        {" "}
                                        Bal After :{" "}
                                        {data?.balanceAfter !== null &&
                                          data.balanceAfter}{" "}
                                      </h6>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-2">
                                    <div class="txntxt">
                                      <h6>
                                        Amount:{" "}
                                        {data.amount !== null && data?.amount}
                                      </h6>
                                      <h6>
                                        {" "}
                                        <span>
                                          {" "}
                                          {data.createdOn
                                            .replace("T", " ")
                                            .slice(0, -4)}{" "}
                                        </span>{" "}
                                      </h6>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-3">
                                    <div class="txntxt">
                                      <h6>
                                        Disc:{" "}
                                        {data?.description !== null &&
                                          data?.description}{" "}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }) : table !== undefined && table !== null && selectedId == null && (isSuperAdmin(id) || isUserAdmin(id)) ? <p style={{color:'red'}} > if You are admin then select the retailer and only maximum 14 days history is allowed</p> :  table !== undefined &&
                    table == null ? <p style={{color:'red'}} >No more than 14 days history is allowed</p> : Array.isArray(table) && table.length == 0 ?<p>{'No record'}</p>  : ''} 
                  {paginationDetails.totalPost !== undefined &&
                    paginationDetails.totalPost !== null &&
                    paginationDetails.totalPost > 0 &&
                    search == "" && (
                      <div class="pager">
                        {table !== undefined &&
                          table !== null &&
                          table.length > 0 &&
                          search == "" && (
                            <p>
                              Showing 1 to{" "}
                              {table.length < 10 ? table.length : table.length}{" "}
                              of{" "}
                              {table !== undefined &&
                                table !== null &&
                                paginationDetails.totalPost}{" "}
                              entries{" "}
                              <button
                                class="lbbtn"
                                type="button"
                                onClick={onExportData}
                              >
                                Export
                              </button>
                            </p>
                          )}

                        {paginationDetails.totalPost !== undefined &&
                          paginationDetails.totalPost !== null &&
                          paginationDetails.totalPost > 10 &&
                          search == "" && (
                            <Pagination
                              className="pagination-bar"
                              currentPage={paginationDetails.currentPage}
                              totalCount={paginationDetails.totalPost}
                              pageSize={paginationDetails.postsPerPage}
                              onPageChange={(page) => handalpageclick(page)}
                            />
                          )}
                      </div>
                    )}
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="mobi-grap"
                role="tabpanel"
                aria-labelledby="mobi-grap-tab"
              >
                {/* <TransactionGraph/>  */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AccountHistory;
